import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'
import { Col, Container, Row, Button, Form, Table, Modal, Offcanvas } from 'react-bootstrap';
import useApi from "../utilities/useApi";
import enums from '../utilities/enums';
import arrayUtilities from '../utilities/arrayUtilities';
import stringUtilities from '../utilities/stringUtilities';
import roleUtilities from '../utilities/roleUtilities';
import dateUtilities from '../utilities/dateUtilities';
import OrganisationSelector from './common/organisationSelector';
import Loading from './common/loading';
import { SidAddOnsModal } from './sidAddOnsModal';
import ErrorModal from './common/errorModal';

export default function AddEditUser(props) {
    const navigate = useNavigate();
    const { organisationId, userId } = useParams();
    const { api } = useApi();
    const usersLandingUrl = `/${organisationId}/users`
    const [filteredOrganisations, setFilteredOrganisations] = useState(null);
    const [modalSid, setModalSid] = useState(null);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [organisation, setOrganisation] = useState("");
    const [roleId, setRoleId] = useState(null);
    const [userCapabilities, setUserCapabilities] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [availableSids, setAvailableSids] = useState(null)    
    const [assignedSids, setAssignedSids] = useState([])    
    const [selectedSids, setSelectedSids] = useState([])
    const [canSave, setCanSave] = useState(false);
    const [showAddSidsModal, setShowAddSidsModal] = useState(false)
    const [error, setError] = useState(null)
    const [inviteUrl, setInviteUrl] = useState(null)
    const [inviteUrlCopied, setInviteUrlCopied] = useState(false)

    useEffect(() => {
        fetchLicenses()
        if (props.isEdit) {
            setIsLoading(true)
            api.getUserById(
            organisationId, userId,
            data => {
                const fullName = data.name.split(" ")
                setFirstName(fullName[0]);
                setLastName(fullName[1]);
                setEmailAddress(data.emailAddress)
                setRoleId(data.roleId);
                setOrganisation(data.organisationalUnitId)
                setIsDisabled(data.disabled)
                setIsDeleted(data.deleted)
                setAssignedSids(data.licenses)
                setSelectedSids(data.licenses.map(item => item.sid))
                setUserCapabilities(data.capabilityIds)
                setIsLoading(false)
                api.getOrganisationalUnits(
                    false,
                    result => {
                        if (arrayUtilities.isNullOrEmpty(result)) {
                            setFilteredOrganisations([])
                        }
                        else if (roleUtilities.hasOrgAdminCapability(props.user)) {
                            setFilteredOrganisations(result)
                        }
                    },
                    error => console.log(error)
                )
            },
            error => {
                console.log(error)
                setIsLoading(false)
            }
        )
        }

    }, [])

    const handleSubmit = () => {
        if (props.isEdit) {
            api.editUser(
                userId, organisationId, firstName, lastName, emailAddress, organisation, isDisabled, roleId, selectedSids, userCapabilities,
                data => {
                    if (data.isError) {
                        setError(data.errorMessage)
                    }
                    else {
                        navigate(usersLandingUrl)
                    }
                },
                error => {
                    console.log(error)
                    setError(error.errorMessage)
                }
            )
        } else {
            api.addUser(props.organisationId, firstName, lastName, emailAddress, roleId, selectedSids, userCapabilities,
            data => {
                if (data.isError) {
                    setError(data.errorMessage)
                } else if (!stringUtilities.isNullOrEmpty(data.inviteUrl)) {
                    setInviteUrl(data.inviteUrl)
                } else {
                    navigate(usersLandingUrl)
                }
            },
            error => {
                setIsLoading(false)
                setError(error.errorMessage)
            }
            )
        }
    }

    const fetchLicenses = () => {
        setIsLoading(true)
        api.getLicenses(
            null, null, 0, organisationId, null, null, false, 0, true, null, null,
            data => {
                setAvailableSids(data.items)
                setIsLoading(false)
            }, 
            error => {
                setIsLoading(false)
            }
        )
    }

    useEffect(() => {
        setCanSave(
            !stringUtilities.isNullOrEmpty(firstName) &&
            !stringUtilities.isNullOrEmpty(lastName) &&
            roleId !== undefined &&
            (props.isEdit ? !stringUtilities.isNullOrEmpty(organisation) : true) &&
            !stringUtilities.isNullOrEmpty(emailAddress)
        )
    }, [firstName, lastName, roleId, organisation, emailAddress])

    return (
        <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2'>
            <Row>
                <Col className='mb-5'>
                    <div className='d-flex justify-content-between my-5'>
                        <h1 className="h2 m-0">{props.isEdit ? "Edit" : "Add"} User</h1>
                    </div>
                    {
                        isLoading
                            ? <Loading />
                            : <>
                                <div>
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            First Name
                                        </Form.Label>
                                        <div className="col-md-9 d-flex">
                                            <Form.Control size='sm' value={ firstName } type="text" onChange={ (e) => setFirstName(e.target.value) } />
                                        </div>
                                    </Form.Group>

                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Last Name
                                        </Form.Label>
                                        <div className="col-md-9 d-flex">
                                            <Form.Control size='sm' value={ lastName } type="text" onChange={ e => setLastName(e.target.value) } />
                                        </div>
                                    </Form.Group>

                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Email Address
                                        </Form.Label>
                                        <div className="col-md-9 d-flex">
                                            <Form.Control size='sm' value={ emailAddress } type="text" onChange={ e => setEmailAddress(e.target.value) } />
                                        </div>
                                    </Form.Group>
                                    {props.isEdit && 
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Organisation
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <OrganisationSelector wrapperClassAddon="w-100" hideIcon value={ organisation } organisations={ filteredOrganisations } onChange={ setOrganisation } />
                                        </div>
                                    </Form.Group>}
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3 pt-0'>
                                            Role
                                        </Form.Label>
                                        <div className="col-md-9">   
                                            <Form.Check 
                                                id='roleId-null'
                                                type='radio' 
                                                name='radio'
                                                checked={ roleId === null } 
                                                key='null'
                                                label="None"
                                                onChange={ e => setRoleId(null) }
                                            />                                         
                                            {
                                                Object.entries(enums.UserRole).map(([key, value]) => { 
                                                    return Number(key) !== 2 ? <Form.Check 
                                                        id={ `roleId-${ key }` }
                                                        type='radio' 
                                                        name='radio'
                                                        checked={ Number(key) === roleId } 
                                                        key={ key } 
                                                        value={ key } 
                                                        label={value}
                                                        onChange={ e => setRoleId(Number(e.target.value)) }
                                                    /> : null;
                                                })
                                            }
                                        </div>
                                    </Form.Group>
                                    {
                                        roleUtilities.hasOrgAdminCapability(props.user) &&
                                        <Form.Group className='mb-3 row'>
                                            <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                                Organizational Unit Administrator
                                            </Form.Label>
                                            <div className="col-md-9 d-flex align-items-center">
                                                <Form.Check 
                                                    type='switch' 
                                                    id="organizational-unit-administrator-enabled" 
                                                    className="me-2" 
                                                    value={ 1 } 
                                                    checked={ userCapabilities.includes(1) } 
                                                    onChange={ e => setUserCapabilities(arrayUtilities.toggle(1, userCapabilities, e.target.checked)) } 
                                                />
                                            </div>
                                        </Form.Group>
                                    }
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            User Administrator
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <Form.Check 
                                                type='switch' 
                                                id="user-administrator-enabled" 
                                                className="me-2" 
                                                value={ 2 } 
                                                checked={ userCapabilities.includes(2) } 
                                                onChange={ e => setUserCapabilities(arrayUtilities.toggle(2, userCapabilities, e.target.checked)) } 
                                            />
                                        </div>
                                    </Form.Group>
                                    {!isDisabled && !isDeleted && 
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Subscription ID(s)
                                        </Form.Label>
                                        <div className="col-md-9">
                                            <Table hover>
                                                <thead>
                                                    <tr>
                                                        {!props.isEdit && <th>&nbsp;</th>}
                                                        <th className='px-0'>SID</th>
                                                        <th>Renewal Date</th>
                                                        <th>Role</th>
                                                        <th>Admin Email</th>
                                                        {props.isEdit && <th className='text-end'>
                                                            <Button variant='secondary' size="sm" onClick={ () => setShowAddSidsModal(true) }>
                                                                <span className='d-flex align-items-center'><i className='fi-plus me-2'></i> Add SID</span>
                                                            </Button></th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        !arrayUtilities.isNullOrEmpty((props.isEdit ? assignedSids : availableSids)) 
                                                        && (props.isEdit ? assignedSids : availableSids)
                                                        .filter(item => !item.isDeleted && item.isEnabled)
                                                        .map(
                                                            sid => <tr key={sid.sid}>
                                                                    {!props.isEdit &&
                                                                    <td className='px-0'>
                                                                        <input
                                                                            id={ sid.sid }
                                                                            onChange={ e => setSelectedSids(arrayUtilities.toggle(e.target.value, selectedSids, e.target.checked)) }
                                                                            className="form-check-input cursor-pointer"
                                                                            type="checkbox"
                                                                            checked={ selectedSids?.includes(sid.sid) }
                                                                            value={sid.sid}
                                                                        />
                                                                    </td>}
                                                                    <td className='px-0'>{sid.sid}</td>
                                                                    <td>{dateUtilities.formatToDateString(sid.renewalDate)}</td>
                                                                    <td>{enums.UserRole[sid.role]}</td>
                                                                    <td>{sid.adminEmail}</td>
                                                                    {props.isEdit && 
                                                                    <td className='text-end'>
                                                                        <Button className='p-0' variant='' size="sm" onClick={ () => setModalSid(sid) }>
                                                                            <i className='fi-trash text-primary'></i>
                                                                        </Button>
                                                                    </td>}
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </Table>
                                            
                                        </div>
                                    </Form.Group>}
                                </div>
                                <Form.Group className='mt-4 row justify-content-end'>
                                    <div className="col-md-9">
                                        <Button onClick={ () => navigate(usersLandingUrl) } variant='outline-primary' size="sm">
                                            Cancel
                                        </Button>
                                        <Button disabled={ !canSave } onClick={ () => handleSubmit() } size='sm' className='ms-2'>
                                            Submit
                                        </Button>
                                    </div>
                                </Form.Group>
                            </>
                    }
                </Col>
            </Row>
            {
            modalSid && 
                <Modal show onHide={() => setModalSid(null)} centered>
                    <Modal.Header>
                        <Modal.Title>Remove SID</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to remove the SID "{modalSid.sid}"?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={() => setModalSid(null)}>Cancel</Button>
                        <Button size="sm" variant="primary" onClick={() => {
                            const selectedSidsIndex = selectedSids.findIndex(item => item === modalSid.sid)
                            setSelectedSids(prevState => prevState.toSpliced(selectedSidsIndex, 1))

                            const assignedSidsIndex = assignedSids.findIndex(item => item.sid === modalSid.sid)
                            setAssignedSids(prevState => prevState.toSpliced(assignedSidsIndex, 1))
                            setModalSid(null)
                        }}>Confirm</Button>
                    </Modal.Footer>
                </Modal>
            }

            {
                showAddSidsModal && !arrayUtilities.isNullOrEmpty(availableSids) &&
                <SidAddOnsModal
                    availableList={ availableSids.filter(item => !selectedSids.includes(item.sid)) }
                    onCancel={ () => setShowAddSidsModal(false) }
                    onConfirm={ sids => {
                        setAssignedSids(prevState => prevState.concat(sids))
                        setSelectedSids(prevState => prevState.concat(sids.map(item => item.sid)))
                        setShowAddSidsModal(false)
                        }
                    }
                />
            }

            {
                !stringUtilities.isNullOrEmpty(inviteUrl) &&
                <Offcanvas show placement='end' scroll={false} backdrop onHide={ () => { setInviteUrl(null); navigate(usersLandingUrl) } }>
                    <Offcanvas.Header className='border-bottom'>
                        <Offcanvas.Title>Invite Successful</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div className="d-flex flex-column h-100 w-100">
                            <div className="w-100 mb-auto">
                                <p className="mb-3">
                                    User has been invited to TerraFlow Geomatics and should receive an email shortly.
                                </p>
                                <p className="mb-3">
                                    If they don't receive it, copy this link and send it to them directly:
                                </p>
                                <div className="d-flex">
                                    <Form.Control size='sm' readOnly value={ inviteUrl } onFocus={ e => e.target.select() } />
                                    <Button
                                        size="sm"
                                        variant='secondary'
                                        className="ms-2 text-nowrap"
                                        onClick={ () => {
                                            navigator.clipboard.writeText(inviteUrl)
                                            setInviteUrlCopied(true)
                                        } }
                                    >
                                        { inviteUrlCopied ? "Copied" : "Copy" }
                                    </Button>
                                </div>
                            </div>
                            <Button size="sm" variant='secondary' className="align-self-start" onClick={ () => { setInviteUrl(null); navigate(usersLandingUrl) } }>Close</Button>
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>
            }

            { !stringUtilities.isNullOrEmpty(error) && <ErrorModal onDismiss={() => setError(null)} error={{message: error}} /> }
        </Container>
    )
}